import { Component, Input, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
    selector: 'app-profile-pic',
    imports: [CommonModule],
    templateUrl: './profile-pic.component.html',
    styleUrl: './profile-pic.component.scss'
})
export class ProfilePicComponent implements OnInit {
  @Input() name: string = ''
  @Input() imageUrl: string | null = null

  nameChars: string = ''

  get imageSrc(): string {
    return this.imageUrl ?? ''
  }

  getNameAcronym() {
    if (!this.name) {
      this.nameChars = ''
      return
    }
    const splittedName = this.name.trim().split(/\s+/).filter(Boolean)
    if (splittedName.length === 0) {
      this.nameChars = ''
      return
    }
    this.nameChars = splittedName[0][0]
    if (splittedName.length > 1) {
      this.nameChars += splittedName[splittedName.length - 1][0]
    }
  }

  ngOnInit(): void {
    this.getNameAcronym()
  }
}
